import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "@/ThemeContext";

type Column = {
  name: string;
  width?: string | number;
};

interface TableSkeletonProps {
  columns: Column[];
  sidebarOpen?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  sidebarOpen = false,
}) => {
  const { isDark } = useTheme();

  return (
    <SkeletonTheme
      baseColor={isDark ? "#2a2a3a" : "#e2e8f0"}
      highlightColor={isDark ? "#3a3a50" : "#f1f5f9"}
    >
      <div
        style={{
          width: "100%",
          background: "var(--surface)",
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          maxHeight: "calc(100vh - 15.75rem)",
          overflow: "hidden",
        }}
      >
        <div>
          {Array.from({ length: 11 }).map((_, i) => (
            <div
              key={i + 1}
              style={{
                padding: "0 16px",
                height: "52px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
                borderBottom: "1px solid var(--border-soft)",
              }}
            >
              {columns?.map((column) => {
                let defaultWidth = "200px";
                const colName = (column.name || "").toLowerCase();
                if (colName.includes("description")) {
                  defaultWidth = "280px";
                } else if (colName.includes("difficulty") || colName.includes("status")) {
                  defaultWidth = "150px";
                } else if (colName.includes("action")) {
                  defaultWidth = "100px";
                } else if (colName.includes("name")) {
                  defaultWidth = "220px";
                }
                const finalWidth = column.width || defaultWidth;
                
                return (
                  <Skeleton
                    key={column.name}
                    width={`calc(${finalWidth} - 1rem)`}
                    height="25px"
                    borderRadius="6px"
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default TableSkeleton;
